export interface ListProps extends React.PropsWithChildren {
  className?: string;
}

const List: React.FC<ListProps> = ({ children, className }) => {
  if (!children || (Array.isArray(children) && children.length === 0))
    return null;
  return (
    <div
      className={`flex flex-col divide-y divide-zinc-200 border border-zinc-200 rounded bg-white ${className}`}
    >
      {children}
    </div>
  );
};

export default List;
